import Vue from 'vue'
import VueI18n from 'vue-i18n'
import sv from './locale/sv.json'
import en from './locale/en.json'

Vue.use(VueI18n)
const locale = 'sv'
const messages = {
  sv: sv,
  en: en
}
const i18n = new VueI18n({
  locale,
  messages,
  fallbackLocale: 'sv',
  silentTranslationWarn: true
})

export default i18n
